var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.getClass()},[_c('div',{staticClass:"maincolumns"},[_c('div',{staticClass:"contentdiv lotterydiv bgnone"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }